"use strict";
import $ from 'jquery';

var Core = $.core.reporting.html = {
    initialize: function () {
        this.build();
        this.events();
    },
    build: function () {
        Core.initDatatables();
        Core.initCharts();
    },
    events: function () {

    },
    initDatatables: function () {
        $('div.report-table-container > table').each(function() {
            try {
                var options = $.core.datatable.staticOptions('item');
                $.core.datatable.build($(this), options);
            } catch (e) {
                // Continue initializing remaining tables and charts if one table fails
            }
        });
    },

    initCharts: function () {
        var chartWidth = $('#report-content').width() || $('#right-builder-frame').width() || 1250;
        $('div.chart-container div.json-chart-data').each(function() {
            //JSON data is contained within the html
            //NOTE: data is passed this way so that pdf generator can grab it directly from the html since it only has access to html
            var data = $.parseJSON($(this).html());
            var $chart = $(this).parent();

            //Remove to avoid bloating html with json data
            $(this).remove();

            var hasMetrics = data.chartType == $.globals.chart.type.pie
                ? data.chartData && data.chartData.data && data.chartData.data.length > 0
                : data.chartData && data.chartData.dataset && data.chartData.dataset.length > 0;

            if (!hasMetrics) {
                $chart.hide();
                return;
            }

            if (data.chartType == $.globals.chart.type.pie) {
                $.core.chart.buildPieChart($chart, data, {width: chartWidth, height: 200, isMultiAxis: true});
            }
            else if (data.chartType == $.globals.chart.type.line) {
                $.core.chart.buildSeriesChart($chart, data, {width: chartWidth, isMultiAxis: true});
            }
            else {
                alert('Invalid chart type');
            }
        });
    }
};